import { z } from "zod";

export const commandTokensSchema = z.object({
	cancelToken: z.string().optional(),
	updateToken: z.string().optional(),
});
export type CommandTokens = z.infer<typeof commandTokensSchema>;
